
export enum SOCKET_ENTRY_EVENT {

  /**
   * Creates a new entry on an open account
   */
  create = 'create:entry',

  /**
   * Updates the values of the current entry
   */
  update = 'update:entry',

  /**
   * Deletes an entry of an open account
   */
  delete = 'delete:entry',
}
